import React from 'react';
import {
  Box, Stack, Table, TableBody, TableCell, TableHead, TableRow,
  Tooltip, Typography,
} from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';

/**
 * Per-fold lift table with shock markers (spec §5.7, §7 J3): users can
 * see whether an edge's lift survives outside shock periods.
 */
const FoldLiftTable = ({ folds = [] }) => {
  if (!folds.length) {
    return (
      <Typography variant="caption" color="text.secondary">
        No fold table recorded (edge predates validation, or run is in progress).
      </Typography>
    );
  }
  return (
    <Box sx={{ overflowX: 'auto' }}>
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell sx={{ py: 0.5 }}>Fold</TableCell>
          <TableCell sx={{ py: 0.5 }} align="right">Lift</TableCell>
          <TableCell sx={{ py: 0.5 }} align="right">Baseline loss</TableCell>
          <TableCell sx={{ py: 0.5 }} align="right">With driver</TableCell>
          <TableCell sx={{ py: 0.5 }} align="center">Shock</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {folds.map((f) => (
          <TableRow key={f.fold} hover>
            <TableCell sx={{ py: 0.5 }}>{f.fold + 1}</TableCell>
            <TableCell sx={{ py: 0.5 }} align="right">
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 600,
                  color: (f.lift || 0) > 0 ? 'success.main' : 'error.main',
                }}
              >
                {((f.lift || 0) * 100).toFixed(2)}%
              </Typography>
            </TableCell>
            <TableCell sx={{ py: 0.5 }} align="right">
              <Typography variant="caption">{Number(f.base_loss).toPrecision(4)}</Typography>
            </TableCell>
            <TableCell sx={{ py: 0.5 }} align="right">
              <Typography variant="caption">{Number(f.full_loss).toPrecision(4)}</Typography>
            </TableCell>
            <TableCell sx={{ py: 0.5 }} align="center">
              {f.has_shock ? (
                <Tooltip title="This fold contains a qualifying shock event — compare its lift against calm folds" arrow>
                  <Stack alignItems="center">
                    <BoltIcon sx={{ fontSize: 14, color: 'warning.main' }} />
                  </Stack>
                </Tooltip>
              ) : null}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
    </Box>
  );
};

export default FoldLiftTable;
